import { useSyncExternalStore } from 'react';

function subscribe(callback) {
  window.addEventListener('online', callback);
  window.addEventListener('offline', callback);
  return () => {
    window.removeEventListener('online', callback);
    window.removeEventListener('offline', callback);
  };
}

export function useNetworkStatus() {
  return useSyncExternalStore(
    subscribe,
    () => navigator.onLine, // Client snapshot
    () => true // Server snapshot (default to true for SSR)
  );
}
